/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/calendar_add'
export default icon
